import { RouteObject } from "react-router-dom";
import AnnouncementRules from "@/pages/system-settings/AnnouncementRules";

export const announcementRuleRoutes: RouteObject[] = [
  {
    path: "/system-settings/announcement-rules",
    element: <AnnouncementRules />,
  },
];
